<template>
  <b-card class="bg-white rounded-xl">
    <div class="flex items-center">
      <div class="mr-2" @click="handleClick('homepage-aboutus')">
        <feather-icon
          icon="ChevronLeftIcon"
          svgClasses="w-7 h-7 font-bold text-black cursor-pointer"
          class=""
        ></feather-icon>
      </div>
      <h2 class="text-2xl font-semibold mt-4 mb-4">Edit Homepage About-Us</h2>
    </div>

    <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
      <b-form role="form" @submit.prevent="handleSubmit(onSubmit)">
        <div class="mb-4">
          <p class="input-title text-black">Title</p>
          <base-input
            alternative
            class="mb-3"
            name="Title"
            placeholder="Heading"
            :rules="{ required: true }"
            v-model="aboutUs_data.heading"
          >
          </base-input>
        </div>

        <div class="mb-4">
          <p class="input-title text-black">Link</p>
          <base-input
            alternative
            class="mb-3"
            name="Link"
            :rules="{ required: true }"
            placeholder="Link"
            v-model="aboutUs_data.link"
          >
          </base-input>
        </div>

        <div class="mb-4">
          <p class="input-title text-black">Description</p>
          <quill-editor
            v-model="aboutUs_data.description"
            :options="editorOption"
            class="quill-h200px my-2"
          />
        </div>

        <div class="mb-4">
          <p class="input-title text-black">Image</p>
          <div
            class="text-sm text-gray-600 font-medium px-2 py-1 mb-1 border rounded bg-gray-100 inline-block"
          >
            Recommended Size: 450 × 300px
          </div>
          <FileUploader
            v-show="!image"
            :image="image"
            :onSuccess="handleSuccess"
          />

          <div v-if="image">
            <p class="mb-2 text-danger">Image Preview</p>

            <div class="flex cursor-pointer items-center my-2" v-if="image">
              <base-button type="danger" class="px-8" @click="handleRemove">
                Remove image
              </base-button>
            </div>
            <span v-if="imageErr" class="small text-danger">{{
              msg.image
            }}</span>
            <img v-if="image" :src="image" ref="cover" />
          </div>

          <div class="mt-3 mb-4">
            <p class="mb-2">Uploaded Image</p>
            <img
              class="w-1/2"
              alt="uploaded-image"
              :src="$imageURL + '/' + aboutUs_data.image"
            />
          </div>
        </div>
        <base-button
          type="primary"
          outline
          class="w-full my-2"
          native-type="submit"
          >Save</base-button
        >
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import FileUploader from "@/components/FileUploader";

import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";

import { mapState } from "vuex";

export default {
  components: {
    FileUploader,
    quillEditor,
  },
  data() {
    return {
      image: "",
      icon: "",
      coverImage: "",
      type: "",
      Ctags: [],
      editorOption: {
        theme: "snow",
      },
      typeOption: [
        {
          value: "main",
          label: "Main",
        },
        {
          value: "other",
          label: "Other",
        },
      ],
      pageData: {},
      aboutUs_data: {},
      imageErr: false,
      msg: {},
    };
  },
  computed: {
    ...mapState("homepage", {
      selectedAboutUs: "selectedAboutUs",
    }),
  },
  watch: {
    pageData(val) {
      this.aboutUs_data = { ...val };
      // console.log(this.aboutUs_data);
    },
  },
  methods: {
    handleSuccess(image) {
      let mByte = 5 * 1048576;

      this.imageErr = false;
      if (!image.type.includes("image")) {
        this.imageErr = true;
        this.msg.image = "Upload Image Only";
      } else {
        this.imageErr = false;
        if (image.size > mByte) {
          this.$swal.fire({
            title: "File size exceeds the allowed limit!",
            // text: "Please ensure that the file size does not exceed 5MB",
            html: "<p style='text-align:center'>Please ensure that the file size does not exceed 5MB</p>",
            confirmButtonText: "Okay",
            icon: "warning",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
          return;
        }
        this.coverImage = image;
        this.readerData(image);
      }
    },

    readerData(rawFile) {
      let loader = this.$loading();

      const reader = new FileReader();
      reader.onload = (e) => {
        this.$emit("load", (this.image = e.target.result));

        loader.close();
      };
      reader.readAsDataURL(rawFile);
    },
    async onSubmit() {
      let FormData = require("form-data");
      let data = new FormData();
      data.append("_id", this.aboutUs_data._id);
      data.append("heading", this.aboutUs_data.heading);
      data.append("image", this.coverImage);
      data.append("description", this.aboutUs_data.description);
      data.append("link", this.aboutUs_data.link);
      let loader = this.$loading();
      try {
        const editData = await this.$store.dispatch(
          "homepage/update_aboutUs",
          data
        );
        // if (editData.code == 200) {
        this.$router.push({ name: "homepage-aboutus" });
        this.$swal.fire({
          text: "Your aboutUs has been successfully edited",
          icon: "success",
          confirmButtonText: "Okay",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
        loader.close();
        // }
      } catch (error) {
        if (error) {
          loader.close();
        }
      }
    },
    async init() {
      this.pageData = this.selectedAboutUs;
    },
    handleRemove() {
      this.image = null;
      this.coverImage = null;
    },
    handleClick(name) {
      this.$router.push({ name: name });
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style>
.h300px {
  height: 300px !important;
}
.imgupload {
  height: 270px !important;
}
</style>
